module.exports = __webpack_public_path__ + "img/receta-icon.52e2f426.svg";